export const navigation = [
  {
    section: "SERVER",
    items: [
      {
        href: "/server/minecraft",
        icon: "🎮",
        label: "Minecraft",
      },
      {
        href: "/server/weather",
        icon: "☁️",
        label: "Weather",
      },
      {
        href: "/server/calendar",
        icon: "📅",
        label: "Calendar",
      },
    ],
  },
  {
    section: "TOOLS",
    items: [
      {
        href: "/server/files",
        icon: "📁",
        label: "File Transfer",
      },
    ],
  },
] as const;

export const mobileNavigation: Array<(typeof navigation)[number]["items"][number]> =
  navigation.flatMap((group) => [...group.items]);